export const REGEX_KH_PHONE = /^(?:0|(?:\+?855))\d{8,9}$/
// Backward-compatible export for modules that have not migrated the name yet.
export const REGEX_VN_PHONE = REGEX_KH_PHONE
export const REGEX_WHITESPACE_AT_BEGINNING_AND_END = /^[^\s]+(\s+[^\s]+)*$/
export const REGEX_WHITESPACE_AT_START_AND_END = /^\s+|\s+$/g
export const REGEX_CUSTOMER_CODE = /^[-_.a-z0-9\u4e00-\u9eff]{1,100}$/i
export const REGEX_EMAIL = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/
export const PASSWORD_STRENGTH_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/
export const PASSWORD_ALLOWED_CHARS_REGEX = /^[A-Za-z\d!@#$%^&*()\-_=+[\]{}|\\:;"'<>,.?/~`]+$/
